import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';
import {
  borderRadius,
  fontSize,
  fontWeight,
  mediaMax,
  spacing,
} from 'presentations/views/styles';
import styled from '@emotion/styled';
import SectionTitle from 'presentations/views/components/molecules/ServiceSectionTitle';
import ServiceSubSectionTitle from 'presentations/views/components/molecules/ServiceSubSectionTitle';
import ContentItem4 from 'presentations/views/components/molecules/ServiceContentItem4';
import { gray05, primary, white } from 'presentations/views/styles/color';
import Icon from 'presentations/views/components/atoms/Icon';
import Headline from 'presentations/views/components/atoms/Headline';

export default function Component() {
  const t = translateInComponent(translations);
  return (
    <>
      <SectionTitle title={t('title')} description={t('description')} />
      <ListContainer2>
        <ListItem2>
          <ContentItem4
            imageUrl="pages/features/security_1.svg"
            imageWidth={84}
            imageHeight={60}
            title={t('item 1 title')}
            description={t('item 1 description')}
          />
        </ListItem2>
        <ListItem2>
          <ContentItem4
            imageUrl="pages/features/security_2.svg"
            imageWidth={90}
            imageHeight={60}
            title={t('item 2 title')}
            description={t('item 2 description')}
          />
        </ListItem2>
        <ListItem2>
          <ContentItem4
            imageUrl="pages/features/security_3.svg"
            imageWidth={75}
            imageHeight={75}
            title={t('item 3 title')}
            description={t('item 3 description')}
          />
        </ListItem2>
      </ListContainer2>
      <ListWrapper>
        <ListTitle variant="h3">{t('other')}</ListTitle>
        <ListContainer>
          <ListItem>
            <TitleContainer>
              <TitleIcon name="check" />
              <Title>{t('security_titles.0')}</Title>
            </TitleContainer>
            <Description>{t('security_descriptions.0')}</Description>
          </ListItem>
          <ListItem>
            <TitleContainer>
              <TitleIcon name="check" />
              <Title>{t('security_titles.1')}</Title>
            </TitleContainer>
            <Description>{t('security_descriptions.1')}</Description>
          </ListItem>
        </ListContainer>
        <ListContainer>
          <ListItem>
            <TitleContainer>
              <TitleIcon name="check" />
              <Title>{t('security_titles.2')}</Title>
            </TitleContainer>
            <Description>{t('security_descriptions.2')}</Description>
          </ListItem>
          <ListItem>
            <TitleContainer>
              <TitleIcon name="check" />
              <Title>{t('security_titles.3')}</Title>
            </TitleContainer>
            <Description>{t('security_descriptions.3')}</Description>
          </ListItem>
        </ListContainer>
        <ListContainer>
          <ListItem>
            <TitleContainer>
              <TitleIcon name="check" />
              <Title>{t('security_titles.4')}</Title>
            </TitleContainer>
            <Description>{t('security_descriptions.4')}</Description>
          </ListItem>
        </ListContainer>
      </ListWrapper>
    </>
  );
}

const ListContainer2 = styled.div`
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  margin-bottom: ${spacing(64)};
  ${mediaMax.tablet} {
    display: block;
  }
`;

const ListItem2 = styled.div`
  width: 32%;
  height: auto;
  ${mediaMax.tablet} {
    width: 100%;
    margin-bottom: ${spacing(24)};
  }
`;
const ListTitle = styled(Headline)`
  text-align: center;
  margin-bottom: ${spacing(24)};
  font-size: ${fontSize(20)};
`;
const ListWrapper = styled.div`
  border-radius: ${borderRadius(12)};
  border: 1px solid ${gray05};
  padding: ${spacing(24)};
  background-color: ${white};
`;
const ListContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${spacing(24)};
  :last-of-type {
    margin-bottom: 0;
  }
  ${mediaMax.tablet} {
    display: block;
  }
`;
const ListItem = styled.div`
  width: 48%;
  ${mediaMax.tablet} {
    width: 100%;
    margin-bottom: ${spacing(16)};
  }
`;
const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${spacing(8)};
`;
const TitleIcon = styled(Icon)`
  margin-right: ${spacing(4)};
  color: ${primary};
`;
const Title = styled.span`
  font-weight: ${fontWeight('bold')};
  font-size: ${fontSize(18)};
`;
const Description = styled.div``;

const SubSectionTitle = styled(ServiceSubSectionTitle)`
  margin-bottom: ${spacing(32)};
`;
